// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__hHh7A","approved":"Status_approved__3IGc2","rejected":"Status_rejected__3BeKe","expired":"Status_expired__1MMgU","label":"Status_label__3a0xf"};